module.exports = __webpack_public_path__ + "img/failover-proof.f21144cc.png";